/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLocationProductRequest
 */
export interface UpdateLocationProductRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationProductRequest
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationProductRequest
     */
    copies?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLocationProductRequest
     */
    printers?: Array<string>;
}

/**
 * Check if a given object implements the UpdateLocationProductRequest interface.
 */
export function instanceOfUpdateLocationProductRequest(value: object): value is UpdateLocationProductRequest {
    return true;
}

export function UpdateLocationProductRequestFromJSON(json: any): UpdateLocationProductRequest {
    return UpdateLocationProductRequestFromJSONTyped(json, false);
}

export function UpdateLocationProductRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocationProductRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'copies': json['copies'] == null ? undefined : json['copies'],
        'printers': json['printers'] == null ? undefined : json['printers'],
    };
}

export function UpdateLocationProductRequestToJSON(json: any): UpdateLocationProductRequest {
    return UpdateLocationProductRequestToJSONTyped(json, false);
}

export function UpdateLocationProductRequestToJSONTyped(value?: UpdateLocationProductRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'copies': value['copies'],
        'printers': value['printers'],
    };
}

